// extracted by mini-css-extract-plugin
module.exports = {"desktop":"FooterMain_desktop_1-Fvi","mobile":"FooterMain_mobile_3kYFi"};